// Module
var code = "<!-- Input -->\n<cjs-input ref=\"inputRange\" inputType=\"range\" class=\"flex-container-column flex-item-auto justify-content-center\">\n</cjs-input>\n<cjs-input ref=\"valueDisplay\" inputType=\"number\" class=\"value-display\"></cjs-input>";
// Exports
module.exports = code;